export const OCR_SIZE_MB = 1024 * 1024;
export const OCR_FILE_SIZE_LIMITS = {
    image: 50,
    pdf: 50,
};
export const MAX_OCR_FILES_COUNT = 20;

export const formatOcrFileSize = (bytes: number): string => {
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isOcrFilePreviewable = (file: File): boolean =>
    file.type === 'application/pdf' || file.type.startsWith('image/');

export const getOcrFileTypeBadge = (file: File): string =>
    file.type === 'application/pdf' ? 'PDF' : file.type.split('/')[1].toUpperCase();

interface FileData {
    mimeType: string;
    src?: string;
    data?: Uint8Array | Int8Array | ArrayBuffer | number[];
}

export const formatfileDataToDataUrl = ({src, data, mimeType}: FileData) => {
    if (src) {
        return src.startsWith('data:') ? src : `data:${mimeType};base64,${src}`;
    }
    if (data) {
        let bytes;
        if (data instanceof Uint8Array)       bytes = data;
        else if (data instanceof Int8Array)   bytes = new Uint8Array(data.buffer);
        else if (data instanceof ArrayBuffer) bytes = new Uint8Array(data);
        else if (Array.isArray(data))         bytes = new Uint8Array(data);
        else return null;

        let bin = '';
        for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);

        return `data:${mimeType};base64,${btoa(bin)}`;
    }
    return null;
};

// IMPORTANT! - remove Object URL -> revokeObjectUrl after the use of base64 formatter
export const base64ToBlobUrl = (base64: string, mimeType: string) => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);

    for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    return URL.createObjectURL(blob);
};
